module.exports = __webpack_public_path__ + "static/ogImage-b8cddd8e3368b7301c70722b3a947465.jpg";